import {
  Button,
  Backdrop,
  CircularProgress,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Grid,
  CardActionArea,
  Chip,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Divider, 
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Confetti from 'react-confetti';
import Tour from 'reactour';
import moment from 'moment';
import WelcomeMessage from 'src/components/WelcomeMessage';
import {
  GetLocation, getTourOpen, getUser, setTourOpen
} from 'src/utils/Common';
import { useTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars';
import { getAnnouncementInfo } from 'src/store/slices/exchangeStatusSlice'
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import EmailIcon from '@material-ui/icons/Email';
import { setAnnouncements } from 'src/store/slices/announcementSlice';
import Announcement from '../OperationCatalog/Announcement';

const useStyles = makeStyles((theme) => ({
  root: {

  },
  posts: {
    marginTop: theme.spacing(2)
  },
  post: {
    marginBottom: theme.spacing(2)
  },
  icon: {
    align: 'center',
    textAlign: 'center'
  },
  cardsMax: {
    maxHeight: 200,
    minHeight: 200
  },
}));

function Timeline({ className, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const [tour, setTour] = React.useState(getTourOpen());
  const [openBirthday, setopenBirthday] = React.useState(false);
  const [announcementInfo, setAnnouncementInfo]= useState([]);

const Announcement = useSelector((state) => state.exchangeStatus.Announcement);

  const steps = [
    {
      content: <Typography variant="h6" gutterBottom>
        Welcome to Sirius Portal Application. Follow the Instructions!...
               </Typography>,
    },
    {
      selector: '[data-tour="OpenNavbarButton"]',
      content: <Typography variant="h6" gutterBottom>
        You can open the menu here
               </Typography>,
      position: 'left',
    },
    {
      selector: '[data-tour="LogoutButton"]',
      content: <Typography variant="h6" gutterBottom>
        You Can Log Out Here
               </Typography>,
      position: 'left',
    },
  ];

  const handleCloseBirthday = () => {
    setopenBirthday(false);
  };


  React.useEffect(() => {
    GetLocation();
    if (parseInt(SessionUser.HappyBirthday) === 1) {
      setTimeout(() => {
        // setopenBirthday(true);
      }, 2000);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(getAnnouncementInfo(SessionUser.Role));
  }, [dispatch]);

  useEffect(() => {
    if(!Announcement){
      return;
    }
    setAnnouncementInfo(Announcement);
  }, [Announcement]);

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Tour
        steps={steps}
        isOpen={tour}
        onRequestClose={() => { setTourOpen(); setTour(false); }}
        accentColor="#FF9800"
        className="helper"
        rounded={20}
      />
      <Card
        {...rest}
        className={clsx(classes.root, className)}

      >
        <CardContent className={classes.content}>
        <Grid container spacing={1}>
        {!announcementInfo ? (
              <div />
            ) : (
              announcementInfo.map((item, index) => (
                <Grid item xs={12} sm={6} lg={6} key={index}
                >
                  <Card className={classes.cardsMax}>
                    <CardActionArea>
                      <CardContent className={classes.cardsContentMax}>
                        <Typography gutterBottom variant="h6" component="h1">
                          
                          <Chip
                            style={{
                              color:'red'
                            }}
                            icon={<EmailIcon />}
                            label={item.Header}
                            
                          />
                          <br />
                            {  moment(item.StartDate).format('DD.MM.YYYY')}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                        
                          <br />
                          <strong>{ 'Message : '} 
                         </strong> 
                         {(item.Dsc) }
                          <br />
                          <strong> {'Create User: ' } </strong> { (item.CreateEmployee)}
                        
                         
                          <br />
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))
            )}
      
    
       </Grid>
        </CardContent>
        <Divider />
      </Card>
      {/* {parseInt(SessionUser.HappyBirthday) === 1 && <Confetti />} */}
      <Dialog
        open={openBirthday}
        onClose={handleCloseBirthday}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Confetti />
          <Typography variant="h6" component="h4">
            <br />
            Sevgili
            {' '}
            {SessionUser.NameSurname}
            ,
            <br />
            <br />
            Doğum gününü kutlar sevdiklerinle birlikte sağlık, mutluluk ve başarılarla dolu
            nice seneler dilerim.
            <br />
            <br />
            İyi ki doğdun!
            <br />
            <br />
            Sevgilerimle,
            <br />
            Hüseyin Şerif Beyaztaş
            <br />
            Arçelik Müşteri Hizmetleri Direktörü
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBirthday} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Timeline.propTypes = {
  className: PropTypes.string
};

export default Timeline;
